import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { SpecialModule } from 'lib/modules/special.module';
import { CmsPartialComponentClass } from 'lib/components/cms/cms-partial-component.class';
import { RouterService } from 'lib/services/router.service';
import { WebpService } from 'lib/services/webp.service';
import { CategoryService } from 'lib/services/category/category.service';

@Component({
    selector: 'cms-partial-category-top-row-set',
    templateUrl: './row-set.component.html',
    styleUrls: ['./row-set.component.scss'],
    standalone: true,
    imports: [CommonModule, SpecialModule],
})
export class RowSetComponent extends CmsPartialComponentClass {
    @Input() rowSetData: any;
    @Input() grayBackgroundRows: any = [];
    getWebpImg: (src: string) => string;

    constructor(
        @Inject('environment') environment: any,
        @Inject(PLATFORM_ID) platformId: Object,
        routerService: RouterService,
        webpService: WebpService,
        location: Location,
        categoryService: CategoryService
    ) {
        super({
            dependencies: {
                platformId,
                environment,
                routerService,
                location,
                categoryService,
            },
        });
        this.getWebpImg = (src: string) => webpService.getWebpImg(src);
    }
}
